/* GCA perf 2026-08-20
 * 1) Lazy mobile navigation: the drawer ships with top-level links only; the full
 *    nested tree is fetched from /?section_id=mobile-navigation-menu on the first
 *    interaction and merged into the existing <details> items.
 * 2) Desktop hover-panel script (moved unchanged from layout/theme.liquid).
 */
(function () {
  var list = document.querySelector('[data-gca-lazy-menu]');
  if (!list) return;
  var promise = null;

  // Placeholder headings expand their own menu instead of navigating to #.
  // Delegate to the list so headings loaded on demand behave the same way.
  list.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('summary > a.details__link[href="#"]');
    if (!link || !list.contains(link)) return;
    var details = link.parentElement.parentElement;
    if (details.tagName !== 'DETAILS') return;
    event.preventDefault();
    details.open = !details.open;
  });


  function hydrate(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var full = doc.querySelector('[data-gca-lazy-menu-full]');
    if (!full) throw new Error('gca-nav-lazy: full menu not found');
    var fullItems = Array.prototype.slice.call(full.children);
    var curItems = Array.prototype.slice.call(list.children);
    var sameShape = fullItems.length === curItems.length && fullItems.every(function (fi, i) {
      var fa = fi.querySelector('a'); var ca = curItems[i].querySelector('a');
      return fa && ca && fa.getAttribute('href') === ca.getAttribute('href');
    });
    if (sameShape) {
      fullItems.forEach(function (fi, i) {
        var ci = curItems[i];
        var fullDetails = fi.firstElementChild && fi.firstElementChild.tagName === 'DETAILS' ? fi.firstElementChild : null;
        var curDetails = ci.firstElementChild && ci.firstElementChild.tagName === 'DETAILS' ? ci.firstElementChild : null;
        if (fullDetails && curDetails) {
          var fc = fullDetails.querySelector(':scope > .details__content');
          var cc = curDetails.querySelector(':scope > .details__content');
          if (fc && cc) { cc.innerHTML = fc.innerHTML; cc.removeAttribute('data-gca-lazy-menu-slot'); }
        } else if (fullDetails || curDetails) {
          ci.replaceWith(fi);
        }
      });
    } else {
      list.innerHTML = full.innerHTML;
    }
    list.setAttribute('data-gca-lazy-menu-state', 'ready');
    document.dispatchEvent(new CustomEvent('gca:mobile-menu:ready'));
  }

  function load() {
    if (promise) return promise;
    list.setAttribute('data-gca-lazy-menu-state', 'loading');
    promise = fetch(list.getAttribute('data-gca-lazy-menu-src'), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('gca-nav-lazy: HTTP ' + r.status); return r.text(); })
      .then(hydrate)
      .catch(function (err) {
        promise = null;
        list.setAttribute('data-gca-lazy-menu-state', 'error');
        if (window.console) console.warn(err);
      });
    return promise;
  }
  window.gcaLoadMobileMenu = load;

  var triggers = document.querySelectorAll('[popovertarget="slideout-mobile-navigation"], [data-wau-slideout-target="mobile-navigation"]');
  Array.prototype.forEach.call(triggers, function (t) {
    ['pointerenter', 'pointerdown', 'touchstart', 'focus', 'click'].forEach(function (ev) {
      t.addEventListener(ev, load, { passive: true });
    });
  });
  var aside = document.getElementById('slideout-mobile-navigation');
  if (aside) {
    aside.addEventListener('beforetoggle', load);
    aside.addEventListener('toggle', load);
  }
  if (window.matchMedia && window.matchMedia('(max-width: 980px)').matches) {
    var evs = ['touchstart', 'pointerdown', 'keydown', 'scroll'];
    var once = function () { load(); evs.forEach(function (ev) { document.removeEventListener(ev, once); }); };
    evs.forEach(function (ev) { document.addEventListener(ev, once, { passive: true }); });
  }
  if (window.Shopify && window.Shopify.designMode) load();
})();

      (() => {
        const activeClass = 'gca-hover-item--active';

        const setActiveSport = (item) => {
          const list = item && item.closest('.gca-hover-list');
          if (!list) return;

          list.querySelectorAll(`.${activeClass}`).forEach((activeItem) => {
            activeItem.classList.remove(activeClass);
          });
          item.classList.add(activeClass);
        };

        const bindMenu = (list) => {
          if (list.dataset.gcaHoverBound === 'true') return;
          list.dataset.gcaHoverBound = 'true';

          list.querySelectorAll('.gca-hover-item--has-panel').forEach((item) => {
            item.addEventListener('mouseenter', () => setActiveSport(item));
            item.addEventListener('pointerenter', () => setActiveSport(item));
            item.addEventListener('focusin', () => setActiveSport(item));
          });

          list.addEventListener('mousemove', (event) => {
            const link = event.target.closest('.gca-hover-link');
            const item = link && link.closest('.gca-hover-item--has-panel');
            if (item && list.contains(item)) setActiveSport(item);
          });
        };

        const primeMenus = () => {
          document.querySelectorAll('nav.navigation .gca-hover-list').forEach((list) => {
            bindMenu(list);
          });
        };

        document.addEventListener('pointerover', (event) => {
          const link = event.target.closest('nav.navigation .gca-hover-link');
          const item = link && link.closest('.gca-hover-item--has-panel');
          if (item) setActiveSport(item);
        });

        document.addEventListener('mouseover', (event) => {
          const link = event.target.closest('nav.navigation .gca-hover-link');
          const item = link && link.closest('.gca-hover-item--has-panel');
          if (item) setActiveSport(item);
        });

        document.addEventListener('focusin', (event) => {
          const link = event.target.closest('nav.navigation .gca-hover-link');
          const item = link && link.closest('.gca-hover-item--has-panel');
          if (item) setActiveSport(item);
        });

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', primeMenus);
        } else {
          primeMenus();
        }
      })();
    

/* GCA 2026-10-02: desktop flyouts live outside scrolling parents.
 * Explicit open state survives pointer travel, including Safari and long lists.
 * Restore the original tree on close/mobile; retain native links and mobile code. */
(() => {
  const desktop = matchMedia('(min-width: 981px)');
  let top = null, row = null, flyout = null, placeholder = null, timer = 0, frame = 0, serial = 0, returningFocus = false;
  const clamp = (v, min, max) => Math.max(min, Math.min(v, Math.max(min, max)));
  const direct = (el, selector) => el?.querySelector(':scope > ' + selector);
  function closeFlyout() {
    if (!row) return;
    flyout.classList.remove('gca-desktop-flyout');
    placeholder.replaceWith(flyout);
    row.classList.remove('gca-flyout-open', 'dropdown__menuitem--active');
    row.setAttribute('aria-expanded', 'false');
    direct(row, 'a')?.setAttribute('aria-expanded', 'false');
    row = flyout = placeholder = null;
  }
  function close() {
    clearTimeout(timer);
    closeFlyout();
    if (top) { top.classList.remove('gca-desktop-menu-open', 'navigation__menuitem--active'); top.setAttribute('aria-expanded', 'false'); }
    top = null;
  }
  function place(panel, left, y, width, availableHeight) {
    panel.classList.add('gca-menu-positioned');
    panel.style.setProperty('--gca-menu-width', width + 'px');
    panel.style.setProperty('--gca-menu-left', left + 'px');
    panel.style.setProperty('--gca-menu-top', y + 'px');
    panel.style.setProperty('--gca-menu-height', Math.max(60, availableHeight) + 'px');
  }
  function update() {
    frame = 0;
    if (!desktop.matches || !top?.isConnected) { close(); return; }
    const zoom = (parseFloat(getComputedStyle(document.documentElement).zoom) || 1) * (parseFloat(getComputedStyle(document.body).zoom) || 1);
    const viewportWidth = innerWidth / zoom, viewportHeight = innerHeight / zoom;
    const rect = el => { const r = el.getBoundingClientRect(); return {left:r.left/zoom, right:r.right/zoom, top:r.top/zoom, bottom:r.bottom/zoom}; };
    const link = direct(top, 'a'), anchor = rect(link);
    const panel = direct(top, '.dropdown'), mega = direct(top, '.megamenu');
    if (panel) {
      const width = Math.min(322, viewportWidth - 16), y = clamp(anchor.bottom, 8, viewportHeight - 80);
      place(panel, clamp(anchor.left - 16, 8, viewportWidth - width - 8), y, width, viewportHeight - y - 8);
    }
    if (mega) mega.style.setProperty('--gca-mega-height', Math.max(80, viewportHeight - rect(mega).top - 8) + 'px');
    if (row && flyout) {
      const parent = rect(row.parentElement), r = rect(direct(row, 'a'));
      // Offscreen trigger after scrolling: close its panel instead of orphaning it.
      if (r.bottom < parent.top || r.top > parent.bottom) { closeFlyout(); return; }
      const width = Math.min(322, viewportWidth - 16);
      const left = parent.right + width <= viewportWidth - 8 ? parent.right - 1 : parent.left - width + 1;
      const naturalHeight = Math.min(flyout.scrollHeight + 2, viewportHeight - 16);
      const y = clamp(r.top - 20, 8, viewportHeight - naturalHeight - 8);
      place(flyout, clamp(left, 8, viewportWidth - width - 8), y, width, viewportHeight - y - 8);
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  function openTop(item) {
    clearTimeout(timer);
    if (top !== item) { close(); top = item; }
    top.classList.add('gca-desktop-menu-open');
    top.setAttribute('aria-expanded', 'true');
    update();
  }
  function openRow(item) {
    if (row === item) return;
    closeFlyout();
    const panel = direct(item, '.dropdown--nested');
    if (!panel) return;
    direct(item, 'a').scrollIntoView({block:'nearest', inline:'nearest'});
    row = item; flyout = panel;
    placeholder = document.createComment('gca desktop flyout');
    panel.before(placeholder);
    if (!panel.id) panel.id = 'gca-desktop-flyout-' + (++serial);
    const link = direct(item, 'a');
    link.setAttribute('aria-controls', panel.id);
    link.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-label', link.textContent.trim());
    item.setAttribute('aria-expanded', 'true');
    item.classList.add('gca-flyout-open');
    panel.classList.add('gca-desktop-flyout');
    item.closest('nav.navigation').append(panel);
    update();
  }
  function enter(event) {
    if (!desktop.matches || !(event.target instanceof Element)) return;
    if (event.type === 'focusin' && returningFocus) { returningFocus = false; return; }
    if (flyout?.contains(event.target)) { clearTimeout(timer); return; }
    const item = event.target.closest('nav.navigation .navigation__menuitem');
    if (!item) { clearTimeout(timer); timer = setTimeout(close, 180); return; }
    openTop(item);
    const child = event.target.closest('.dropdown__menuitem--nested');
    if (child && child.closest('.navigation__menuitem') === item) openRow(child);
    else if (event.target.closest('.dropdown__menuitem')) closeFlyout();
  }
  document.addEventListener('pointerover', enter);
  document.addEventListener('mouseover', enter);
  document.addEventListener('focusin', enter);
  document.addEventListener('focusout', () => setTimeout(() => {
    if (top && !top.contains(document.activeElement) && !flyout?.contains(document.activeElement) && !top.matches(':hover') && !flyout?.matches(':hover')) close();
  }, 0));
  document.addEventListener('keydown', event => {
    if (!desktop.matches || !(event.target instanceof Element)) return;
    const item = event.target.closest('nav.navigation .navigation__menuitem');
    if (!item && !flyout?.contains(event.target)) return;
    const child = event.target.closest('.dropdown__menuitem--nested');
    if (event.key === 'ArrowLeft' && flyout?.contains(event.target)) {
      event.preventDefault(); const back = direct(row, 'a'); closeFlyout(); returningFocus = true; back?.focus(); return;
    }
    if (event.key === 'Escape') {
      event.preventDefault(); const back = row ? direct(row, 'a') : direct(top, 'a');
      close(); back?.focus(); close(); return;
    }
    if (child && ['ArrowRight','ArrowDown'].includes(event.key)) {
      event.preventDefault(); openTop(item); openRow(child); flyout?.querySelector('a')?.focus(); return;
    }
    if (event.key === 'ArrowDown' && item && event.target === direct(item, 'a')) {
      event.preventDefault(); openTop(item); direct(item, 'ul')?.querySelector('a')?.focus(); return;
    }
    if (event.key === 'Tab' && row && event.target === direct(row, 'a') && !event.shiftKey) {
      event.preventDefault(); flyout.querySelector('a')?.focus();
    }
  });
  document.addEventListener('pointerdown', event => {
    if (desktop.matches && !event.target.closest('nav.navigation')) close();
  });
  document.addEventListener('scroll', schedule, {capture:true, passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  desktop.addEventListener('change', () => { close(); document.querySelectorAll('nav.navigation .gca-menu-positioned').forEach(p=>p.classList.remove('gca-menu-positioned')); });
  document.addEventListener('shopify:section:unload', close);
})();
